import constants from '../shared/constants';
import { formatDate, initializeTurnstile } from '../shared/functions';

document.addEventListener('DOMContentLoaded', (): void => {
    const newsletterWidgets = document.querySelectorAll<HTMLElement>(constants.targets.newsletterWidget.widget);

    newsletterWidgets.forEach((widget) => {
        const client = widget.dataset.smartconnectionsClient;
        const form = widget.querySelector<HTMLFormElement>(constants.targets.newsletterWidget.form);

        if (!client || !form) return;

        const honeypotField = form.querySelector<HTMLElement>(constants.targets.newsletterWidget.honeypotField);
        const honeypotInput = form.querySelector<HTMLInputElement>(constants.targets.newsletterWidget.honeypotInput);
        const visibleField = form.querySelector<HTMLElement>(constants.targets.newsletterWidget.visibleField);
        const visibleInput = form.querySelector<HTMLInputElement>(constants.targets.newsletterWidget.visibleInput);
        const turnstileContainer = form.querySelector<HTMLElement>(constants.targets.newsletterWidget.turnstile);
        const submitButton = form.querySelector<HTMLButtonElement>(constants.targets.newsletterWidget.submit);

        if (!honeypotField || !honeypotInput || !visibleField || !visibleInput || !turnstileContainer || !submitButton) return;

        honeypotInput.required = false;
        honeypotField.hidden = true;

        visibleInput.type = 'email';
        visibleInput.required = true;

        if (honeypotInput.placeholder) {
            visibleInput.placeholder = honeypotInput.placeholder;
        }

        submitButton.disabled = true;
        submitButton.classList.add(constants.classes.hidden);

        const setSubmitAvailability = (isAvailable: boolean): void => {
            submitButton.disabled = !isAvailable;
            submitButton.classList.toggle(constants.classes.hidden, !isAvailable);
            turnstileContainer.classList.toggle(constants.classes.hidden, isAvailable);
        };

        initializeTurnstile(turnstileContainer, (completed) => {
            setSubmitAvailability(completed);
        });

        submitButton.addEventListener('click', (event: MouseEvent) => {
            if (!submitButton.classList.contains(constants.classes.newsletterWidget.submitCheck)) return;

            event.preventDefault();

            if (honeypotInput.value !== '') return;

            form.action = `https://${client}.crmplatform.nl/engine?check=${btoa(formatDate(new Date()))}`;
            submitButton.classList.remove(constants.classes.newsletterWidget.submitCheck);
            submitButton.classList.add(constants.classes.newsletterWidget.doSubmit);

            if (typeof form.requestSubmit === 'function') {
                form.requestSubmit(submitButton);
                return;
            }

            form.submit();
        });
    });
});
